import { IFundRule } from '../rules/ifund-rule'
import { FilterHandlerResultType } from './filter-handler-result-type.enum'
import { FundCategoryModel } from './fund-category-model'

export abstract class AbstractFilterHandlerResultModel {
  public abstract getAppliedFundRule(): IFundRule
  public abstract getFundGroupList(): FundCategoryModel[]
  public abstract getFilterHandlerResultType(): FilterHandlerResultType
}
